export enum AccountType {
    user = 'user',
    organisation = 'organisation',
    organisationUser = 'organisationUser'

}
